import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

function formatWarehouseCount(row) {
  const ids = row?.warehouseIds;
  if (!Array.isArray(ids) || ids.length === 0) {
    return '0';
  }
  return String(ids.length);
}

export const processingFactorySideMsgBlocks = [
  {
    fields: [
      { label: '代號', value: 'code' },
      { label: '名稱', value: 'name' },
      { label: '中文名', value: (row) => dash(row?.chineseName) },
      { label: '統編', value: (row) => dash(row?.taxIdNumber) },
      { label: '電話', value: (row) => dash(row?.phone) },
      { label: '工作倉數', value: formatWarehouseCount },
      { label: '狀態', value: entityStatusSideMsgValue },
      { label: '備註', value: (row) => dash(row?.remark) },
      {
        key: 'actions',
        render: (row) => {
          if (!row?.id) {
            return null;
          }
          return (
            <div className="side_msg-row">
              <h3>操作</h3>
              <div className="mt-1">
                <Button type="button" asChild>
                  <Link to={ROUTES.processingFactoryEdit(row.id)}>編輯</Link>
                </Button>
              </div>
            </div>
          );
        },
      },
    ],
  },
];
